interface TabButtonProps {
  id: string;
  panelId: string;
  label: string;
  isSelected: boolean;
  onClick: () => void;
  isDisabled?: boolean;
}

export const TabButton = ({
  id,
  panelId,
  label,
  isSelected,
  onClick,
  isDisabled,
}: TabButtonProps) => {
  return (
    <button
      type="button"
      role="tab"
      id={id}
      aria-selected={isSelected}
      aria-controls={panelId}
      tabIndex={isSelected ? 0 : -1}
      onClick={onClick}
      className="rounded-full bg-transparent px-3 py-2 font-medium text-gray-500 text-sm transition-colors hover:bg-gray-50 aria-selected:bg-[rgba(199,210,254,0.24)] aria-selected:font-semibold aria-selected:text-gray-950"
      disabled={isDisabled}
    >
      {label}
    </button>
  );
};
